import React, { useState } from "react";
import s from "./FAQ.module.scss";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import "react-accessible-accordion/dist/fancy-example.css";
import {
  QuestionCircleOutlined,
  EditOutlined,
  CaretDownOutlined,
  CaretUpOutlined,
} from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const FAQ = () => {
  const [openedAccordionKey, setOpenedAccordionKey] = useState(0);
  const { t } = useTranslation();

  return (
    <div className={s.faq}>
      <div className={s.wrapper}>
        <h2 className={s.h2} data-aos='fade-up' data-aos-duration='2000'>
          {t("Часто задаваемые вопросы")}&nbsp;
          <QuestionCircleOutlined className={s.question_icon} />{" "}
        </h2>

        <div className={s.subtitle} data-aos='fade-up' data-aos-duration='3000'>
          <EditOutlined /> &nbsp;
          {t(
            "Задайте нам вопросы и ответы на самые популярные будут опубликованы."
          )}
        </div>
        <Accordion
          allowZeroExpanded
          className={s.accordion}
          allowMultipleExpanded={false}
        >
          <AccordionItem key={1} className={s.item}>
            <AccordionItemHeading
              className={s.heading}
              onClick={(e) => setOpenedAccordionKey(1)}
            >
              <AccordionItemButton className={s.btn}>
                <div>
                  1. {t("Какой формат финансирования предоставляет Фонд?")}
                </div>
                <div>
                  {openedAccordionKey === 1 ? (
                    <CaretUpOutlined className={s.icon} />
                  ) : (
                    <CaretDownOutlined className={s.icon} />
                  )}
                </div>
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel className={s.panel}>
              {t(
                "Фонд предоставляет инвестиции путём участия в капитале компаний в качестве партнёра соучредителя или акционера с максимальной долей до 49% от суммы реализуемого проекта."
              )}
            </AccordionItemPanel>
          </AccordionItem>

          <AccordionItem key={2} className={s.item}>
            <AccordionItemHeading
              className={s.heading}
              onClick={(e) => setOpenedAccordionKey(2)}
            >
              <AccordionItemButton className={s.btn}>
                <div>
                  2. {t("Какой размер инвестиций может предоставить Фонд?")}
                </div>
                <div>
                  {openedAccordionKey === 2 ? (
                    <CaretUpOutlined className={s.icon} />
                  ) : (
                    <CaretDownOutlined className={s.icon} />
                  )}
                </div>
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel className={s.panel}>
              {t(
                "Сумма инвестиций Фонда может составлять от 200 000$ до 20 000 000$ на один проект."
              )}
            </AccordionItemPanel>
          </AccordionItem>

          <AccordionItem key={3} className={s.item}>
            <AccordionItemHeading
              className={s.heading}
              onClick={(e) => setOpenedAccordionKey(3)}
            >
              <AccordionItemButton className={s.btn}>
                <div className={s.question}>
                  3.{" "}
                  {t(
                    "Возможно ли получение финансирования Физическим лицом или Индивидуальным Предпринимателем?"
                  )}
                </div>
                <div>
                  {openedAccordionKey === 3 ? (
                    <CaretUpOutlined className={s.icon} />
                  ) : (
                    <CaretDownOutlined className={s.icon} />
                  )}
                </div>
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel className={s.panel}>
              {t(
                "На текущий момент Инвестиционное участие Фонда подразумевает обязательное участие инициатора в виде юридического лица"
              )}
            </AccordionItemPanel>
          </AccordionItem>

          <AccordionItem key={4} className={s.item}>
            <AccordionItemHeading
              className={s.heading}
              onClick={(e) => setOpenedAccordionKey(4)}
            >
              <AccordionItemButton className={s.btn}>
                <div>
                  4. {t("На какой срок предоставляется инвестиции Фонда?")}
                </div>
                <div>
                  {openedAccordionKey === 4 ? (
                    <CaretUpOutlined className={s.icon} />
                  ) : (
                    <CaretDownOutlined className={s.icon} />
                  )}
                </div>
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel className={s.panel}>
              {t(
                "В зависимости от проекта максимальное участие Фонда ограничено сроком 5-7 лет."
              )}
            </AccordionItemPanel>
          </AccordionItem>

          <AccordionItem key={5} className={s.item}>
            <AccordionItemHeading
              className={s.heading}
              onClick={(e) => setOpenedAccordionKey(5)}
            >
              <AccordionItemButton className={s.btn}>
                <div>
                  5.{" "}
                  {t(
                    "Предоставляется ли льготный период по возврату инвестиций?"
                  )}
                </div>
                <div>
                  {openedAccordionKey === 5 ? (
                    <CaretUpOutlined className={s.icon} />
                  ) : (
                    <CaretDownOutlined className={s.icon} />
                  )}
                </div>
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel className={s.panel}>
              {t(
                "В зависимости от условий реализации проекта со стороны Фонда предусмотрено предоставление льготного периода сроком до 2-х лет. (на срок инвестиционной фазы)."
              )}
            </AccordionItemPanel>
          </AccordionItem>

          <AccordionItem key={6} className={s.item}>
            <AccordionItemHeading
              className={s.heading}
              onClick={(e) => setOpenedAccordionKey(6)}
            >
              <AccordionItemButton className={s.btn}>
                <div>
                  6. {t("Какие требуются документы для рассмотрения Фондом?")}
                </div>
                <div>
                  {openedAccordionKey === 6 ? (
                    <CaretUpOutlined className={s.icon} />
                  ) : (
                    <CaretDownOutlined className={s.icon} />
                  )}
                </div>
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel className={s.panel}>
              {t("Можете изучить список требуемых документов на нашем сайте")}
              &nbsp;
              <Link to='/requirements' className={s.link}>
                https://www.akdf.kg/requirements
              </Link>
            </AccordionItemPanel>
          </AccordionItem>

          <AccordionItem key={7} className={s.item}>
            <AccordionItemHeading
              className={s.heading}
              onClick={(e) => setOpenedAccordionKey(7)}
            >
              <AccordionItemButton className={s.btn}>
                <div>7. {t("Требуется ли обязательное страхование?")} </div>
                <div>
                  {openedAccordionKey === 7 ? (
                    <CaretUpOutlined className={s.icon} />
                  ) : (
                    <CaretDownOutlined className={s.icon} />
                  )}
                </div>
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel className={s.panel}>
              {t(
                "Необходимо обязательное страхование ключевого имущества созданного, приобретённого или участвующего в рамках инвестиционного проекта совместно с АКФР."
              )}
              &nbsp;
              <Link to='/insuranceCompanies' className={s.link}>
                «{t("accreditedInsuranceCompanies")}»
              </Link>
              .
            </AccordionItemPanel>
          </AccordionItem>
          <AccordionItem key={8} className={s.item}>
            <AccordionItemHeading
              className={s.heading}
              onClick={(e) => setOpenedAccordionKey(8)}
            >
              <AccordionItemButton className={s.btn}>
                <div>
                  8.{" "}
                  {t(
                    "Имеются ли штрафные санкции за не своевременное исполнение обязательств перед Фондом?"
                  )}
                </div>
                <div>
                  {openedAccordionKey === 8 ? (
                    <CaretUpOutlined className={s.icon} />
                  ) : (
                    <CaretDownOutlined className={s.icon} />
                  )}
                </div>
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel className={s.panel}>
              {t(
                "В рамках инвестиционного соглашения с Фондом предусмотрена неустойка за несвоевременное исполнение /неисполнение обязательств."
              )}
              <br /> <strong>А)</strong>{" "}
              {t("Нецелевое использование инвестиционных средств")} <br />{" "}
              {t("Кроме этого, предусматривается право Фонда")}: <br /> 1)&nbsp;
              {t("Приостановить финансирование")}; <br /> 2)&nbsp;
              {t("Осуществить полный досрочный возврат инвестиций")}; <br />
              3)&nbsp;{t("Расторгнуть инвестиционное соглашение с инициатором")}
              . <br />
              <p></p> <strong>Б)</strong>{" "}
              {t(
                "Несвоевременный возврат вложенных инвестиций АКФР – 0,05% от суммы просроченного платежа за каждый просроченный день."
              )}
            </AccordionItemPanel>
          </AccordionItem>
          <AccordionItem key={9} className={s.item}>
            <AccordionItemHeading
              className={s.heading}
              onClick={(e) => setOpenedAccordionKey(9)}
            >
              <AccordionItemButton className={s.btn}>
                <div>
                  9. {t("В какой валюте можно получить финансирование?")}
                </div>
                <div>
                  {openedAccordionKey === 9 ? (
                    <CaretUpOutlined className={s.icon} />
                  ) : (
                    <CaretDownOutlined className={s.icon} />
                  )}
                </div>
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel className={s.panel}>
              {t(
                "Фонд рассматривает возможность участия в проекте в долларах США и Кыргызских сомах в зависимости от Формата проекта."
              )}
            </AccordionItemPanel>
          </AccordionItem>
          <AccordionItem key={10} className={s.item}>
            <AccordionItemHeading
              className={s.heading}
              onClick={(e) => setOpenedAccordionKey(10)}
            >
              <AccordionItemButton className={s.btn}>
                <div>
                  10.{" "}
                  {t(
                    "Укажите целевое направление инвестиционных средств Фонда?"
                  )}
                </div>
                <div>
                  {openedAccordionKey === 10 ? (
                    <CaretUpOutlined className={s.icon} />
                  ) : (
                    <CaretDownOutlined className={s.icon} />
                  )}
                </div>
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel className={s.panel}>
              {t("Целевое назначение инвестиций:")}
              <br />•{" "}
              {t(
                "приобретение оборудования и техники включая расходы на логистику, таможенную очистку и пр."
              )}
              <br />• {t("выполнение строительно-монтажных работ")}
              <br />•{" "}
              {t("приобретение объектов недвижимости (в рамках проекта)")}
              <br />• {t("реконструкция и ремонт объектов недвижимости")}
              <br />• {t("приобретение доли в капитале юридического лица")}
              <br />• {t("финансирование оборотного капитала")}
              <br />•{" "}
              {t(
                "финансирование производственных процессов, включая разработку программного обеспечения"
              )}
              <br />• {t("финансирование маркетинговых мероприятий")}
            </AccordionItemPanel>
          </AccordionItem>
          <AccordionItem key={11} className={s.item}>
            <AccordionItemHeading
              className={s.heading}
              onClick={(e) => setOpenedAccordionKey(11)}
            >
              <AccordionItemButton className={s.btn}>
                <div>
                  11.{" "}
                  {t(
                    "Какой должен быть процент собственного участия инициатора проекта?"
                  )}
                </div>
                <div>
                  {openedAccordionKey === 11 ? (
                    <CaretUpOutlined className={s.icon} />
                  ) : (
                    <CaretDownOutlined className={s.icon} />
                  )}
                </div>
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel className={s.panel}>
              {t(
                "Инвестиционная политика Фонда подразумевает собственное участие инициатора в размере не менее 51% от суммы проекта."
              )}
            </AccordionItemPanel>
          </AccordionItem>
          <AccordionItem key={12} className={s.item}>
            <AccordionItemHeading
              className={s.heading}
              onClick={(e) => setOpenedAccordionKey(12)}
            >
              <AccordionItemButton className={s.btn}>
                <div>12. {t("Существует ли компонент рефинансирования?")}</div>
                <div>
                  {openedAccordionKey === 12 ? (
                    <CaretUpOutlined className={s.icon} />
                  ) : (
                    <CaretDownOutlined className={s.icon} />
                  )}
                </div>
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel className={s.panel}>
              {t("Нет, компонент рефинансирования отсутствует.")}
            </AccordionItemPanel>
          </AccordionItem>
          <AccordionItem key={13} className={s.item}>
            <AccordionItemHeading
              className={s.heading}
              onClick={(e) => setOpenedAccordionKey(12)}
            >
              <AccordionItemButton className={s.btn}>
                <div>
                  13.
                  {t(
                    "В какое время мы можем записаться на консультацию в Фонде?"
                  )}
                </div>
                <div>
                  {openedAccordionKey === 12 ? (
                    <CaretUpOutlined className={s.icon} />
                  ) : (
                    <CaretDownOutlined className={s.icon} />
                  )}
                </div>
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel className={s.panel}>
              {t(
                "Консультация в Фонде возможна только после подачи электронной заявки в Фонд через наш сайт www.akdf.kg и после получения письма-приглашения на консультацию."
              )}
            </AccordionItemPanel>
          </AccordionItem>
          <AccordionItem key={14} className={s.item}>
            <AccordionItemHeading
              className={s.heading}
              onClick={(e) => setOpenedAccordionKey(12)}
            >
              <AccordionItemButton className={s.btn}>
                <div>
                  14.{" "}
                  {t(
                    "Есть ли у Фонда Грантовая программа для поддержки малообеспеченных слоев населения?"
                  )}
                </div>
                <div>
                  {openedAccordionKey === 12 ? (
                    <CaretUpOutlined className={s.icon} />
                  ) : (
                    <CaretDownOutlined className={s.icon} />
                  )}
                </div>
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel className={s.panel}>
              {t(
                "Фонд не предоставляет гранты для поддержки малообеспеченных слоёв населения."
              )}
            </AccordionItemPanel>
          </AccordionItem>
          <AccordionItem key={15} className={s.item}>
            <AccordionItemHeading
              className={s.heading}
              onClick={(e) => setOpenedAccordionKey(12)}
            >
              <AccordionItemButton className={s.btn}>
                <div>
                  15.{" "}
                  {t(
                    "Мы получили приглашение принять участие в спортивных играх для детей, которые будут проходить в Баку. Но для этого необходимо приобрести билеты в обе стороны. Сможет ли Фонд помочь купить билеты для этих целей?"
                  )}
                </div>
                <div>
                  {openedAccordionKey === 12 ? (
                    <CaretUpOutlined className={s.icon} />
                  ) : (
                    <CaretDownOutlined className={s.icon} />
                  )}
                </div>
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel className={s.panel}>
              {t(
                "Фонд, к сожалению, не осуществляет финансирование расходов на проезд, включая приобретение билетов, в рамках участия в различных мероприятиях."
              )}
            </AccordionItemPanel>
          </AccordionItem>
          <AccordionItem key={16} className={s.item}>
            <AccordionItemHeading
              className={s.heading}
              onClick={(e) => setOpenedAccordionKey(12)}
            >
              <AccordionItemButton className={s.btn}>
                <div>
                  16.{" "}
                  {t(
                    "Есть ли у Фонда программа кредитования? Нам нужна помощь для получения льготного кредита."
                  )}
                </div>
                <div>
                  {openedAccordionKey === 12 ? (
                    <CaretUpOutlined className={s.icon} />
                  ) : (
                    <CaretDownOutlined className={s.icon} />
                  )}
                </div>
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel className={s.panel}>
              {t(
                "Фонд не предоставляет программы кредитования для физических и юридических лиц, включая помощь в получении льготных кредитов"
              )}
              <br />
              {t(
                "Основной деятельностью Фонда является осуществление инвестиций путём участия в капитале компаний в целях содействия развитию самоокупаемых проектов в приоритетных отраслях экономики."
              )}
            </AccordionItemPanel>
          </AccordionItem>
          <AccordionItem key={17} className={s.item}>
            <AccordionItemHeading
              className={s.heading}
              onClick={(e) => setOpenedAccordionKey(12)}
            >
              <AccordionItemButton className={s.btn}>
                <div>
                  17.{" "}
                  {t(
                    "Можете ли мне помочь для составления бизнес плана и ТЭО моего проекта?"
                  )}
                </div>
                <div>
                  {openedAccordionKey === 12 ? (
                    <CaretUpOutlined className={s.icon} />
                  ) : (
                    <CaretDownOutlined className={s.icon} />
                  )}
                </div>
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel className={s.panel}>
              {t(
                "Фонд, к сожалению, не оказывает услуг по составлению бизнес-планов и технико-экономических обоснований (ТЭО) проектов. Эти виды поддержки не входят в его компетенцию."
              )}{" "}
              <br />
              {t(
                "Но также необходимо отметить что на официальном сайте Фонда www.akdf.kg в разделе «Аккредитация» указан перечень аккредитованных консультантов по составлению бизнес планов, технико-экономического обоснования и прочих отраслевых экспертиз. Данные специалисты также как и прочие специалисты представленные в Кыргызстане могут составить Вам бизнес план в соответствии с вашим проектом и запросом."
              )}
            </AccordionItemPanel>
          </AccordionItem>
          <AccordionItem key={18} className={s.item}>
            <AccordionItemHeading
              className={s.heading}
              onClick={(e) => setOpenedAccordionKey(12)}
            >
              <AccordionItemButton className={s.btn}>
                <div>
                  18.{" "}
                  {t(
                    "У меня есть проект в области аграрной промышленности. Какие виды поддержки или консультационной помощи предоставляет Фонд проектам в сфере аграрной промышленности и фермерских хозяйств?"
                  )}
                </div>
                <div>
                  {openedAccordionKey === 12 ? (
                    <CaretUpOutlined className={s.icon} />
                  ) : (
                    <CaretDownOutlined className={s.icon} />
                  )}
                </div>
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel className={s.panel}>
              {t(
                "Азербайджано-Кыргызский Фонд развития оказывает поддержку проектам в аграрной сфере, включая фермерские хозяйства."
              )}
            </AccordionItemPanel>
          </AccordionItem>
          <AccordionItem key={19} className={s.item}>
            <AccordionItemHeading
              className={s.heading}
              onClick={(e) => setOpenedAccordionKey(12)}
            >
              <AccordionItemButton className={s.btn}>
                <div>
                  19.&nbsp;
                  {t(
                    "Я ознакомился с условиями финансирования Фондом. Спасибо, все понятно. У меня вопрос: Как и каким образом я могу оценить свое имущества и какие требования Фонда к оценщикам?"
                  )}
                </div>
                <div>
                  {openedAccordionKey === 12 ? (
                    <CaretUpOutlined className={s.icon} />
                  ) : (
                    <CaretDownOutlined className={s.icon} />
                  )}
                </div>
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel className={s.panel}>
              {t(
                "В Кыргызской Республике оценочная деятельность регулируется Законом «Об оценочной деятельности» и стандартами оценки, утвержденными Кабинетом Министров."
              )}
            </AccordionItemPanel>
          </AccordionItem>
          <AccordionItem key={20} className={s.item}>
            <AccordionItemHeading
              className={s.heading}
              onClick={(e) => setOpenedAccordionKey(12)}
            >
              <AccordionItemButton className={s.btn}>
                <div>
                  20.{" "}
                  {t(
                    "Поддерживаете ли вы проект этно-комплекса для иностранных туристов."
                  )}
                </div>
                <div>
                  {openedAccordionKey === 12 ? (
                    <CaretUpOutlined className={s.icon} />
                  ) : (
                    <CaretDownOutlined className={s.icon} />
                  )}
                </div>
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel className={s.panel}>
              {t(
                "Фонд рассматривает возможность поддержки проектов, направленных на развитие туризма, включая создание этно-комплексов для иностранных туристов, при условии, что проект соответствует требованиям Фонда и имеет экономическое обоснование. Решение о финансировании принимается после детального рассмотрения представленного бизнес-плана и ТЭО."
              )}
            </AccordionItemPanel>
          </AccordionItem>
          <AccordionItem key={21} className={s.item}>
            <AccordionItemHeading
              className={s.heading}
              onClick={(e) => setOpenedAccordionKey(12)}
            >
              <AccordionItemButton className={s.btn}>
                <div>
                  21.{" "}
                  {t(
                    "Ищем инвестора со входом в долю проекта по созданию цифровых платформ «Маркетплейса». Сможете ли быть инвестором?"
                  )}
                </div>
                <div>
                  {openedAccordionKey === 12 ? (
                    <CaretUpOutlined className={s.icon} />
                  ) : (
                    <CaretDownOutlined className={s.icon} />
                  )}
                </div>
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel className={s.panel}>
              {t(
                "Фонд может участвовать в проектах в виде инвестора, включая вхождение в уставный капитал предприятия."
              )}
              {t(
                "Такой формат финансирования предусмотрен уставом Фонда и применяется в случаях, если проект соответствует его приоритетам и обладает высоким потенциалом развития."
              )}{" "}
              <br />{" "}
              {t(
                "В случае с вашим проектом по созданию цифровой платформы (маркетплейса), вы можете подать заявку, приложив:"
              )}{" "}
              <br /> {t("• бизнес-план с финансовой моделью;")} <br />
              {t("• ТЭО (если есть);")} <br />{" "}
              {t("• описание команды и текущего статуса проекта;")}
              <br />
              {t("• предложение по долевому участию Фонда.")} <br />{" "}
              {t(
                "Фонд будет оценивать проект с точки зрения его инновационности, устойчивости, потенциала масштабирования и влияния на экономику."
              )}
            </AccordionItemPanel>
          </AccordionItem>
          <AccordionItem key={22} className={s.item}>
            <AccordionItemHeading
              className={s.heading}
              onClick={(e) => setOpenedAccordionKey(12)}
            >
              <AccordionItemButton className={s.btn}>
                <div>
                  22.
                  {t(
                    "Я получил финансовую поддержку от Фонда, за что благодарю Вас."
                  )}
                </div>
                <div>
                  {openedAccordionKey === 12 ? (
                    <CaretUpOutlined className={s.icon} />
                  ) : (
                    <CaretDownOutlined className={s.icon} />
                  )}
                </div>
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel className={s.panel}>
              {t(
                "Да, вы можете подать заявку на получение финансовой поддержки от Фонда для нового проекта."
              )}{" "}
              <br />{" "}
              {t(
                "Ранее полученное финансирование и успешная реализация проекта, а также соблюдение условий возврата инвестиций — это положительные факторы, которые могут быть учтены при рассмотрении вашей новой заявки."
              )}{" "}
              <br />
              {t("Для подачи нового проекта вам потребуется:")} <br />
              {t("• обновлённый бизнес-план и ТЭО;")} <br />
              {t("• подтверждение финансовой устойчивости;")}
              <br />
              {t("• краткое описание результатов предыдущего проекта;")}
              <br /> {t("• информация о вашей команде и опыте.")}
              <br />{" "}
              {t(
                "Рекомендуется также указать, что вы уже сотрудничали с Фондом и успешно выполняете обязательства — это укрепит доверие."
              )}
            </AccordionItemPanel>
          </AccordionItem>
        </Accordion>
      </div>
    </div>
  );
};

export default FAQ;
